<template>
  <div class="login-page" dir="rtl">
    <van-icon name="arrow-left" class="back-icon" @click="goBack" />
    <h1>تسجيل الدخول</h1>
    <form @submit.prevent="login" class="rtl-form">
      <van-field
        v-model="username"
        label="اسم المستخدم:"
        placeholder="الرجاء إدخال اسم المستخدم"
        required
        :label-align="'right'"
        input-align="right"
        dir="ltr"
      />
      <van-field
        v-model="password"
        type="password"
        label="كلمة المرور:"
        placeholder="الرجاء إدخال كلمة المرور"
        required
        :label-align="'right'"
        input-align="right"
        dir="rtl"
      />
      <van-button type="primary" native-type="submit" block
        >تسجيل الدخول</van-button
      >
    </form>
    <p class="register-link">
      <a @click="goToRegister">اذهب للتسجيل</a>
    </p>
  </div>
</template>

<script>
import { Button, Field, Toast, Icon } from "vant";
import { defineComponent } from "vue";
import { loginUser } from "@/api/api.js";

export default defineComponent({
  name: "UserLogin",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Icon.name]: Icon,
  },
  data() {
    return {
      username: "",
      password: "",
      redirect: "",
    };
  },
  created() {
    this.redirect = this.$route.query.redirect || "/";
  },
  methods: {
    async login() {
      try {
        console.log("Username:", this.username);
        console.log("Password:", this.password);
        const data = await loginUser({
          username: this.username,
          password: this.password,
        });
        if (data.code === "failed") {
          Toast.fail(data.message);
        } else {
          Toast.success("تم تسجيل الدخول بنجاح");
          window.location.href = this.redirect;
        }
      } catch (error) {
        console.error("Error:", error);
        Toast.fail("حدث خطأ أثناء تسجيل الدخول");
      }
    },
    goToRegister() {
      this.$router.replace({
        path: "/register",
        query: { redirect: this.redirect },
      });
    },
    goBack() {
      this.$router.replace(this.redirect);
    },
  },
});
</script>

<style scoped>
.login-page {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  font-family: "Arial", sans-serif;
}

.rtl-form {
  text-align: right;
}

.login-page h1 {
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
  color: #333;
}

:deep(.van-field__label) {
  color: #333;
  font-weight: 600;
}

:deep(.van-button--primary) {
  margin-top: 20px;
  height: 44px;
  font-size: 16px;
  background-color: #2c3e50;
  border-color: #2c3e50;
}

:deep(.van-button--primary:active) {
  background-color: #1a2633;
  border-color: #1a2633;
}

.register-link {
  text-align: center;
  margin-top: 20px;
}

.register-link a {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 600;
}

.register-link a:hover {
  color: #1a2633;
}

.back-icon {
  position: absolute;
  top: 20px;
  right: 10px;
  cursor: pointer;
  z-index: 100;
  transform: rotate(180deg);
}
</style>
